module.exports = __webpack_public_path__ + "img/orcamento.a52d1e6c.svg";